export const decorateMessage = ({ message, messageValues }) => {
	let translatedMessage = message;

	translatedMessage = message.replace(
		RegExp(
			Object.keys(messageValues)
				.map((value) => `{${value}}`)
				.join("|"),
			"g",
		),
		function (value) {
			const trimmed = value.replace(/[{}]/g, "");
			return messageValues[trimmed];
		},
	);

	return translatedMessage;
};
